import styled from 'styled-components';

export const MarginTopWrapper = styled.div`
  margin-top: -54px;
`;
